import React from "react";

function Assessments() {
  return (
    <div>
      <h1 className="title">Take a Mental Health Assessment today!</h1>
      <br></br>
      <div className="test-container">
        <div>
          <p className="category">ADHD</p>
          <ul>
            <li>
              <a
                href="https://screening.mhanational.org/screening-tools/adhd/?ref"
                className="test-link"
              >
                Mental Health America
              </a>
              <br></br>
              <a
                href="https://www.mind-diagnostics.org/adhd-test"
                className="test-link"
              >
                Mind Diagnostics
              </a>
              <br></br>
              <a
                href="https://psychcentral.com/quizzes/adhd-quiz"
                className="test-link"
              >
                PsychCentral
              </a>
              <br></br>
              <a
                href="https://www.psychologytoday.com/us/tests/health/adhdattention-deficit-disorder-test"
                className="test-link"
              >
                Psychology Today
              </a>
            </li>
          </ul>
        </div>

        <div>
          <p className="category">Anxiety</p>
          <ul>
            <li>
              <a
                href="https://screening.mhanational.org/screening-tools/anxiety/?ref"
                className="test-link"
              >
                Mental Health America
              </a>
              <br></br>
              <a
                href="https://screening.mentalhealthscreening.org/ga/screening/59373"
                className="test-link"
              >
                Mindwise
              </a>
              <br></br>
              <a
                href="https://www.mind-diagnostics.org/anxiety-test"
                className="test-link"
              >
                Mind Diagnostics
              </a>
              <br></br>
              <a
                href="https://psychcentral.com/quizzes/anxiety-quiz"
                className="test-link"
              >
                PsychCentral
              </a>
              <br></br>
              <a
                href="https://www.talkspace.com/assessments/anxiety-test"
                className="test-link"
              >
                Talkspace
              </a>
            </li>
          </ul>
        </div>

        <div>
          <p className="category">Bipolar</p>
          <ul>
            <li>
              <a
                href="https://screening.mhanational.org/screening-tools/bipolar/?ref"
                className="test-link"
              >
                Mental Health America
              </a>
              <br></br>
              <a
                href="https://screening.mentalhealthscreening.org/ga/screening/59377"
                className="test-link"
              >
                Mindwise
              </a>
              <br></br>
              <a
                href="https://psychcentral.com/quizzes/bipolar-quiz"
                className="test-link"
              >
                PsychCentral
              </a>
              <br></br>
              <a
                href="https://www.psychologytoday.com/us/tests/health/bipolar-depression-test"
                className="test-link"
              >
                Psychology Today
              </a>
              <br></br>
              <a
                href="https://www.talkspace.com/assessments/bipolar-disorder-test"
                className="test-link"
              >
                Talkspace
              </a>
            </li>
          </ul>
        </div>

        <div>
          <p className="category">Depression</p>
          <ul>
            <li>
              <a
                href="https://screening.mhanational.org/screening-tools/depression/?ref"
                className="test-link"
              >
                Mental Health America
              </a>
              <br></br>
              <a
                href="https://www.mind-diagnostics.org/depression-test"
                className="test-link"
              >
                Mind Diagnostics
              </a>
              <br></br>
              <a
                href="https://screening.mentalhealthscreening.org/ga/screening/59371"
                className="test-link"
              >
                Mindwise
              </a>
              <br></br>
              <a
                href="https://psychcentral.com/quizzes/depression-quiz"
                className="test-link"
              >
                PsychCentral
              </a>
              <br></br>
              <a
                href="https://www.talkspace.com/assessments/depression-test"
                className="test-link"
              >
                Talkspace
              </a>
            </li>
          </ul>
        </div>

        <div>
          <p className="category">Eating Disorder</p>
          <ul>
            <li>
              <a
                href="https://screening.mhanational.org/screening-tools/eating-disorder/?ref"
                className="test-link"
              >
                Mental Health America
              </a>
              <br></br>
              <a
                href="https://screening.mentalhealthscreening.org/ga/screening/59376"
                className="test-link"
              >
                Mindwise
              </a>
              <br></br>
              <a
                href="https://www.mind-diagnostics.org/eating_disorder-test"
                className="test-link"
              >
                Mind Diagnostics
              </a>
              <br></br>
              <a
                href="https://psychcentral.com/quizzes/eating-disorders-quiz"
                className="test-link"
              >
                PsychCentral
              </a>
            </li>
          </ul>
        </div>

        <div>
          <p className="category">Gambling</p>
          <ul>
            <li>
              <a
                href="https://www.mind-diagnostics.org/gambling_addiction-test"
                className="test-link"
              >
                Mind Diagnostics
              </a>
              <br></br>
              <a
                href="https://screening.mentalhealthscreening.org/ga/screening/59381"
                className="test-link"
              >
                Mindwise
              </a>
            </li>
          </ul>
        </div>

        <div>
          <p className="category">OCD</p>
          <ul>
            <li>
              <a
                href="https://www.mind-diagnostics.org/ocd-test"
                className="test-link"
              >
                Mind Diagnostics
              </a>
              <br></br>
              <a
                href="https://psychcentral.com/quizzes/ocd-quiz#1"
                className="test-link"
              >
                PsychCentral
              </a>
              <br></br>
              <a
                href="https://www.talkspace.com/assessments/obsessive-compulsive-disorder-test"
                className="test-link"
              >
                Talkspace
              </a>
            </li>
          </ul>
        </div>

        <div>
          <p className="category">Postpartum</p>
          <ul>
            <li>
              <a
                href="https://screening.mhanational.org/screening-tools/postpartum-depression/?ref"
                className="test-link"
              >
                Mental Health America
              </a>
              <br></br>
              <a
                href="https://www.mind-diagnostics.org/postpartum_depression-test"
                className="test-link"
              >
                Mind Diagnostics
              </a>
              <br></br>
              <a
                href="https://psychcentral.com/quizzes/postpartum-depression-quiz"
                className="test-link"
              >
                PsychCentral
              </a>
              <br></br>
              <a
                href="https://www.talkspace.com/assessments/postpartum-depression-test"
                className="test-link"
              >
                Talkspace
              </a>
            </li>
          </ul>
        </div>

        <div>
          <p className="category">Psychosis</p>
          <ul>
            <li>
              <a
                href="https://screening.mhanational.org/screening-tools/psychosis/?ref"
                className="test-link"
              >
                Mental Health America
              </a>
              <br></br>
              <a
                href="https://www.mind-diagnostics.org/psychosis-test"
                className="test-link"
              >
                Mind Diagnostics
              </a>
              <br></br>
              <a
                href="https://screening.mentalhealthscreening.org/ga/screening/59379"
                className="test-link"
              >
                Mindwise
              </a>
            </li>
          </ul>
        </div>

        <div>
          <p className="category">PTSD</p>
          <ul>
            <li>
              <a
                href="https://screening.mhanational.org/screening-tools/ptsd/?ref"
                className="test-link"
              >
                Mental Health America
              </a>
              <br></br>
              <a
                href="https://screening.mentalhealthscreening.org/ga/screening/59374"
                className="test-link"
              >
                Mindwise
              </a>
              <br></br>
              <a
                href="https://www.mind-diagnostics.org/ptsd-test"
                className="test-link"
              >
                Mind Diagnostics
              </a>
              <br></br>
              <a
                href="https://psychcentral.com/quizzes/ptsd-quiz"
                className="test-link"
              >
                PsychCentral
              </a>
              <br></br>
              <a
                href="https://www.talkspace.com/assessments/ptsd-test"
                className="test-link"
              >
                Talkspace
              </a>
            </li>
          </ul>
        </div>

        <div>
          <p className="category">Substance Use</p>
          <ul>
            <li>
              <a
                href="https://screening.mhanational.org/screening-tools/addiction/?ref"
                className="test-link"
              >
                Mental Health America - Alcohol Use
              </a>
              <br></br>
              <a
                href="https://screening.mentalhealthscreening.org/ga/screening/59372"
                className="test-link"
              >
                Mindwise - Alcohol Use
              </a>
              <br></br>
              <a
                href="https://screening.mhanational.org/screening-tools/addiction/?ref"
                className="test-link"
              >
                Mental Health America - Drug Use
              </a>
              <br></br>
              <a
                href="https://screening.mentalhealthscreening.org/ga/screening/59383"
                className="test-link"
              >
                Mindwise - Drug Use
              </a>
            </li>
          </ul>
        </div>

        <div>
          <p className="category">Wide Range</p>
          <ul>
            <li>
              <a
                href="https://screening.mentalhealthscreening.org/ga/screening/59380"
                className="test-link"
              >
                Mindwise
              </a>
              <br></br>
              <a
                href="https://www.psychologytoday.com/us/tests/health/mental-health-assessment"
                className="test-link"
              >
                Psychology Today
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Assessments;
